import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import {
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Paper,
  Grid,
  DialogActions
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
// import RfsStyles from '';
import RfsStyles from '../rfs/rfs.module.css';
import commonStyles from '../common/common.module.css';
import MaterialTable from 'material-table';
import Zoom from '@material-ui/core/Zoom';
import moment from 'moment';
import AwbsDataTable from '../../models/AwbsDataTable';
import Awb from '../../models/Awb';

const styles = (theme: Theme) =>
  createStyles({
    rowContainer: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    button: {
      width: '100%',
      height: '34px',
      textTransform: 'none',
    },
    warning: {
        color: 'red',
        fontSize: '14px',
    },
    materialIcon: {
      margin: '10px 3px 0',
      fontSize: 20,
      '&:hover': {
        cursor: 'pointer',
      },
    },
  });

interface AwbHistoryProps {
  classes: any;
  modalOpen: boolean;
  handleClose: (type: string) => void;
  awbHistory: Array<Awb>;
  proceed: Function;
  refreshDisable: boolean;
  selectedAwb: Awb;
  selectAwb: Function;
  type: 'import' | 'export';
}

const shipmentHistory = (props: AwbHistoryProps) => {
  const { classes } = props;

  return (
    <Dialog
      open={props.modalOpen}
      onClose={() => props.handleClose('history')}
      aria-labelledby='form-dialog-title'
      maxWidth={'md'}
      fullWidth={true}
      TransitionComponent={Zoom}
      transitionDuration={500}>
      <DialogTitle id='form-dialog-title'>
        <div className={RfsStyles.dialogTitle}>
          <span className={RfsStyles.name}>Duplicate AWB detected</span>
          <IconButton
            aria-label='Close'
            className={RfsStyles.close}
            onClick={() => props.handleClose('history')}>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div className={ classes.warning }>The Air waybill you are trying to add to the order, already exists in the system</div>
        <div className= {`${ commonStyles.wrapper } ${ commonStyles.my2 } ${ commonStyles.SelectTable }`}>
          <h3 className={ commonStyles.header }> Awbs </h3>
          <MaterialTable
            components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
            onRowClick={ (event: any, rowData: any) => props.selectAwb(rowData) }
            columns={[
                {
                    title: 'AWB',
                    field: '',
                    render: (awb: Awb) => {
                  return `${awb.code}-${awb.number}`;
                }
                  },
              {
                title: 'Flight',
                field: '',
                render: (awb: Awb) => {
                  return  awb.export_metadata.firstFlightNumber + ' - ' + moment(awb.export_metadata.firstFlightDate).format('DD MMM YYYY');
                },
              },
              {
                title: 'Pcs',
                field: 'pieces'
              },
              {
                title: 'Weight',
                field: 'weight',
              },
              {
                title: 'Origin',
                field: 'origin'
              },
              {
                title: 'Dest',
                field: 'destination',
              },
              {
                title: 'Status',
                field: 'status',
              },
            ]}
            data={props.awbHistory}
            options={{
              paging: false,
              pageSize: 10,
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 2,
              },
              rowStyle: (rowData: Awb) => ({
                color: (props.selectedAwb === rowData) ? '#fff' : '#000',
                transition: '0s',
              }),
              showTitle: false,
              pageSizeOptions: [15, 20],
              toolbar: false,
              sorting: false,
            }}
          />
        </div>
        <div className={ classes.warning }>Are you sure you wish to add the same air waybill number again?</div>
      </DialogContent>
      <DialogActions>
      <Button
          className={classes.submitBtn}
          variant="contained"
          color="primary"
          onClick={() => props.proceed('step0')}
          disabled={ Object.keys(props.selectedAwb).length === 0 }
        >
       Select Awb
        </Button>
        <Button
          className={classes.submitBtn}
          variant="contained"
          color="primary"
          onClick={() => props.proceed('step1')}
          disabled={ !props.refreshDisable }
        >
        Yes, I am sure
        </Button>
        <Button
          className={classes.submitBtn}
          variant="contained"
          color="primary"
          onClick={() => props.handleClose('history')}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(shipmentHistory);
